import * as React from 'react';
import Divider from './divider';

export interface CollapseProps {
    title: string;
    noleftMargin?: boolean;
    overrideToggle?: (collapsed: boolean) => boolean;
    collapsed?: boolean;
}

export interface CollapseState {
    collapsed: boolean;
}

export default class Collapse extends React.Component<CollapseProps, CollapseState> {
  constructor(props: CollapseProps) {
    super(props);
    this.state = {
        collapsed: this.props.collapsed || true,
    };
  }

  componentWillReceiveProps(nextProps: CollapseProps) {
    if (nextProps.collapsed !== this.props.collapsed) {
      this.setState({collapsed: nextProps.collapsed || this.state.collapsed});
    }
  }

  handleCollapse = () => {
    const newState = this.props.overrideToggle? this.props.overrideToggle(this.state.collapsed) : !this.state.collapsed;
    this.setState({collapsed: newState});
  }

  public render() {
      return (
          <div className={"collapse " + (this.props.noleftMargin ? "no-left-margin" : "")}>
              <Divider/>
              <h1 onClick={this.handleCollapse} className={"collapse-title " + (this.state.collapsed? "collapsed": "") }>
                  {this.state.collapsed && <span >+</span>}
                  {!this.state.collapsed && <span>-</span>}
                  {this.props.title}
              </h1>
              {!this.state.collapsed &&
              <div className="collapse-content">
                  {this.props.children}
              </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/collapse.tsx